import { AuthState } from '@okta/okta-auth-js';

import { TradeAccounts } from '../../services/backend/TradeAccounts';
import { useBaseApiClient } from '../useBaseApiClient';

export const useTradeAccounts: () => TradeAccounts<AuthState> = () => {
  return useBaseApiClient(TradeAccounts);
};
